import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { makeStyles } from '@material-ui/styles';
import DateFnsUtils from '@date-io/date-fns';
import 'react-confirm-alert/src/react-confirm-alert.css';
import Alert from 'src/components/Alert';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import ExposurePlus1Rounded from '@material-ui/icons/ExposurePlus1Rounded';
import {
  Avatar,
  Button,
  Card,
  CardContent,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Snackbar,
  Grid,
  List,
  ListItem,
  ListItemText,
  ListItemAvatar,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TextField,
  Typography,
  Backdrop,
  ThemeProvider,
  createMuiTheme,
  IconButton
} from '@material-ui/core';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider
} from '@material-ui/pickers';
import Page from 'src/components/Page';
import 'react-confirm-alert/src/react-confirm-alert.css';
import CircularProgress from '@material-ui/core/CircularProgress';
import { useTranslation } from 'react-i18next';
import Autocomplete from '@material-ui/lab/Autocomplete';
import trLocale from 'date-fns/locale/tr';
import moment from 'moment';
import SearchIcon from '@material-ui/icons/Search';
import axios from 'src/utils/axios';
import EditIcon from '@material-ui/icons/Edit';
import { getUser } from 'src/utils/Common';
import ExcelExport from 'src/components/ServiceShopMaterialExcelExport';
import AddBoxIcon from '@material-ui/icons/AddBox';

const useStyles = makeStyles(theme => ({
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0)'
  },
  root: {
    paddingTop: theme.spacing(0),
    paddingBottom: theme.spacing(0)
  },
  cardscontent: {
    minHeight: 530
  },
  tableRow: {
    '&$hover:hover': {
      backgroundColor: '#f5f5f5'
    }
  },
  tableCell: {
    '$hover:hover &': {
      color: 'black'
    }
  },
  hover: {},
  nestedRight: {
    backgroundColor: theme.palette.common.white,
    marginLeft: theme.spacing(1),
    marginBottom: theme.spacing(1),
    marginRight: theme.spacing(7)
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff'
  },
  container: {
    maxHeight: 630
  }
}));
const localeMap = {
  tr: trLocale
};

const siyah = '#424242';
const materialTheme = createMuiTheme({
  palette: {
    primary: {
      contrastText: '#FFFFFF',
      dark: siyah,
      main: siyah,
      light: siyah
    }
  }
});

function ServiceShopMaterial() {

  const classes = useStyles();
  const { t } = useTranslation('overview');
  const dispatch = useDispatch();
  const [regionSelected, setRegionSelected] = useState('');
  const [regionList, setRegionList] = useState([]);
  const [serviceShopSelected, setServiceShopSelected] = useState('');
  const [subServiceShopList, setSubServiceShopList] = useState([]);
  const [initialRows, setinitialRows] = useState([]);
  const [serviceShopMaterialPopUp, setServiceShopMaterialPopUp] = useState(false);
  const [stokData, setStokData] = useState([]);
  const [DisabledControl, setDisabledControl] = useState(false);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [StartDateSearch, setStartDateSearch] = useState(
    moment()
      .startOf('day')
      .add(-7, 'days')
      .add(12, 'hours')
      .format('YYYY-MM-DD')
  );
  const [EndDateSearch, setEndDateSearch] = useState(new Date());
  const [materialCode, setMaterialCode] = useState(0);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [responseMessage, setresponseMessage] = useState({
    ErrorCode: '0',
    ErrorDescription: t('success_message')
  });
  const [uyari, setUyari] = React.useState(false);
  const [uyariTip, setUyariTip] = React.useState('default');
  const locale = localStorage.getItem('i18nextLng');
  const SessionUser = getUser();

  const getRegionForServiceShop = async () => {
    setLoading(true);
    axios.get('/GetRegionForServiceShop')
      .then(response => {
        const res = response.data;
        dispatch(setRegionList(res));
        setLoading(false);
      })
      .catch(error => {
        setLoading(false);
      });

  }

  useEffect(() => {
    if (parseInt(SessionUser.Role) === 1 || parseInt(SessionUser.Role) === 2) {
      setDisabledControl(true);
      setServiceShopSelected({ ServiceShopId: SessionUser.ServiceShopId });
    }
  }, [SessionUser.Role]);


  useEffect(() => {
    getRegionForServiceShop();
  }, [locale]);

  const handleChangeStartDateSearch = e => {
    setStartDateSearch(e);
  };
  const handleChangeEndDateSearch = e => {
    setEndDateSearch(e);
  };

  const getServiceShopForRegion = async (region) => {
    setLoading(true);
    axios.get('/GetServiceShopForRegion/' + region.RegionId)
      .then((response) => {
        setSubServiceShopList(response.data)
        setLoading(false);
      })
      .catch(error => {
        setLoading(false);
      });
  }

  async function changeRegion(region) {
    setLoading(true);
    getServiceShopForRegion(region)
    setRegionSelected(region)
    setLoading(false);
  }

  async function changeService(serviceShop) {
    setServiceShopSelected(serviceShop);
  }

  const getStokColor = s => {
    if (s.Quantity > 0) {
      return (
        <Avatar
          size="small"
          style={{ color: 'white', backgroundColor: 'green' }}
        >
          <ShoppingCartIcon />
        </Avatar>
      );
    } else {
      return (
        <Avatar
          size="small"
          onClick={() => {
            setUyari(s.Date || '');
            setOpen(true);
          }}
          style={{ color: '#424242', backgroundColor: 'red' }}
        >
          <ShoppingCartIcon />
        </Avatar>
      );
    }
  };

  const getServiceShopMaterials = async (temp) => {
    axios.get(`/GetServiceShopMaterials/${temp[0]}/${temp[1]}/${temp[2]}`)
      .then((response) => {
        setinitialRows(response.data)
        setLoading(false);
      })
      .catch(error => {
        setLoading(false);
      });
  }

  async function searchMaterials() {
    const StartDate = moment(StartDateSearch).format('YYYY-MM-DD');
    const EndDate = moment(EndDateSearch).format('YYYY-MM-DD');
    const temp = [serviceShopSelected?.ServiceShopId || 0, StartDate, EndDate];
    getServiceShopMaterials(temp);
  }

  const setServiceShopMaterialPopUpParam = (row) => {
    setMaterialCode(row.MaterialCode);
    setSelectedIndex(row.MaterialCode);
    var serviceShopCode = serviceShopSelected != "" ? serviceShopSelected?.SourceServiceShopCode : "";
    const Request = {
      MaterialCode: [row.MaterialCode],
      ServiceShopCode: serviceShopCode
    };

    const RequestHeaders = {
      headers: { 'Content-Type': 'application/json' }
    };
    axios
      .post('/GetMaterialAvailabilitySirius', Request, RequestHeaders)
      .then(response => {
        const res = response.data.length === 0 ? [] : response.data;
        const stokQuantity = res.map(item => ({
          ...item,
          Quantity: parseInt(item.Quantity, 10)
        }));
        setStokData(stokQuantity);
       
        setLoading(false);
      })
      .catch(error => {
        setLoading(false);
      });
    setServiceShopMaterialPopUp(true);
  };

  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(false);
  };

  const clickNonBeko = (row, index) => {
    try {
      row.InStock = row.InStock - 1;
      row.NonBeko = row.NonBeko + 1;
      let data = [...initialRows]
      data.splice(index , 1, row)
      setinitialRows(data)
      NonBeko_Ordered_API(row, "NonBeko")
    } catch (error) {
      console.log(error)
    }
  }

  const clickOrdered = (row, index) => {
    try {
      row.InStock = row.InStock - 1;
      row.Ordered = row.Ordered + 1;
      let data = [...initialRows]
      data.splice(index , 1, row)
      setinitialRows(data)
      NonBeko_Ordered_API(row, "Ordered")
    } catch (error) {
      console.log(error)
    }
  }

  const NonBeko_Ordered_API = (row, api) => {
    try {
      axios
      .get(
        `/UpdateServiceShopMaterials/${row.MaterialId}/${row[api]}/${row.InStock}`
        )
        .then(data => {
          console.log(data);
        })
        .catch(error => {
          console.log(error);
        });
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <Page title="">
      <Backdrop className={classes.backdrop} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar open={uyari} autoHideDuration={10000} onClose={uyariKapat}>
        <Alert
          onClose={uyariKapat}
          message={responseMessage.ErrorDescription}
          variant={uyariTip}
        />
      </Snackbar>
      <Container maxWidth="xl" spacing={1} className={classes.root}>
        <Card>
          <CardContent>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={3} lg={2}>
                <Autocomplete
                  size="small"
                  fullWidth
                  autoSelect
                  disabled={DisabledControl}
                  disableClearable
                  value={regionSelected || null}
                  options={regionList || []}
                  getOptionLabel={option => (option.Dsc ? option.Dsc : '')}
                  getOptionSelected={(option, value) =>
                    option.RegionId === value.RegionId
                  }
                  renderInput={params => (
                    <TextField
                      {...params}
                      label={t('Region')}
                      variant="outlined"
                    />
                  )}
                  onChange={(event, value) => {
                    changeRegion(value);
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={3} lg={2}>
                <Autocomplete
                  size="small"
                  fullWidth
                  autoSelect
                  disableClearable
                  disabled={DisabledControl}
                  value={serviceShopSelected || null}
                  options={subServiceShopList || []}
                  getOptionLabel={option => (option.Dsc ? option.Dsc : '')}
                  getOptionSelected={(option, value) =>
                    option.ServiceShopId === value.ServiceShopId
                  }
                  renderInput={params => (
                    <TextField
                      {...params}
                      label={t('lblServiceShop')}
                      variant="outlined"
                    />
                  )}
                  onChange={(event, value) => {
                    changeService(value);
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={2} lg={2}>
                <ThemeProvider theme={materialTheme}>
                  <MuiPickersUtilsProvider
                    utils={DateFnsUtils}
                    locale={localeMap[locale]}
                  >
                    <KeyboardDatePicker
                      color="primary"
                      inputVariant="outlined"
                      id="orderDate"
                      size="small"
                      invalidDateMessage={t('hatali_tarih')}
                      format="dd.MM.yyyy"
                      fullWidth
                      label={t('BaslangicTarihi')}
                      variant="outlined"
                      value={StartDateSearch}
                      onChange={e => handleChangeStartDateSearch(e)}
                      KeyboardButtonProps={{
                        'aria-label': 'change date'
                      }}
                    />
                  </MuiPickersUtilsProvider>
                </ThemeProvider>
              </Grid>
              <Grid item xs={12} sm={2} lg={2}>
                <ThemeProvider theme={materialTheme}>
                  <MuiPickersUtilsProvider
                    utils={DateFnsUtils}
                    locale={localeMap[locale]}
                  >
                    <KeyboardDatePicker
                      color="primary"
                      inputVariant="outlined"
                      id="orderDate"
                      size="small"
                      invalidDateMessage={t('hatali_tarih')}
                      format="dd.MM.yyyy"
                      fullWidth
                      autoComplete="off"
                      label={t('BitisTarihi')}
                      variant="outlined"
                      value={EndDateSearch}
                      onChange={e => handleChangeEndDateSearch(e)}
                      KeyboardButtonProps={{
                        'aria-label': 'change date'
                      }}
                    />
                  </MuiPickersUtilsProvider>
                </ThemeProvider>
              </Grid>
              <Grid item xs={12} sm={2} lg={2}>
                <Button
                  fullWidth
                  variant="contained"
                  color="primary"
                  size="small"
                  onClick={() => searchMaterials()}
                  endIcon={<SearchIcon />}
                >
                  {t('lblSearch')}
                </Button>
              </Grid>
              <Grid item xs={12} sm={2} lg={2}>
                <ExcelExport JsonData={initialRows} title={t('lblExport')} />
              </Grid>
            </Grid>
          </CardContent>
          <CardContent>
            <br />
            <TableContainer className={classes.container}>
              <Table stickyHeader aria-label="sticky table" size="small">
                <TableHead>
                  <TableRow>
                    <TableCell align="left">
                      {t('lblMaterialCode')}
                    </TableCell>
                    <TableCell align="left">
                      {t('lblMaterialName')}
                    </TableCell>
                    <TableCell align="left">
                      {t('lblInStock')}
                    </TableCell>
                    <TableCell align="left">
                      {t('lblOrdered')}
                    </TableCell>
                    <TableCell align="left">
                      {t('lblUsed')}
                    </TableCell>
                    <TableCell align="left">
                      {t('lblNonBeko')}
                    </TableCell>
                    <TableCell align="left">
                      {t('lblReturned')}
                    </TableCell>
                    <TableCell align="left">
                      {"Non Beko +1"}
                    </TableCell>
                    <TableCell align="left">
                      {"Returned +1"}
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {initialRows && initialRows?.map((row, index) => (
                    <TableRow key={index}>
                      <TableCell align="left">{row.MaterialCode}</TableCell>
                      <TableCell align="left">{row.MaterialName}</TableCell>
                      <TableCell align="left">
                        <Button
                          variant="contained"
                          color="primary"
                          size="small"
                          onClick={() => setServiceShopMaterialPopUpParam(row)}
                          style={selectedIndex === row.MaterialCode ? { backgroundColor: '#CC0000' } : {}}
                          endIcon={<EditIcon />}
                        >
                          {row.InStock}
                        </Button>
                      </TableCell>
                      <TableCell align="left">{row.Ordered}</TableCell>
                      <TableCell align="left">{row.Used}</TableCell>
                      <TableCell align="left">
                        {row.NonBeko}
                      </TableCell>
                      <TableCell align="left">
                        {row.Returned}
                      </TableCell>
                      <TableCell align="left">
                        <IconButton 
                          onClick={()=>{clickNonBeko(row, index)}}
                          size="small"
                        >
                          <AddBoxIcon />
                        </IconButton>
                      </TableCell>
                      <TableCell align="left">
                        <IconButton 
                          onClick={()=>{clickOrdered(row, index)}}
                          size="small"
                        >
                          <AddBoxIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </CardContent>
        </Card>
      </Container>
      <Dialog
        open={serviceShopMaterialPopUp}
        onClose={() => setServiceShopMaterialPopUp(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
      >
        <DialogTitle id="alert-dialog-title">
          {t('lblMaterialStockSituation')}
          <Divider />
        </DialogTitle>
        <DialogContent>
          <List component="div" dense>
            {
              stokData.map(s => {
                return (
                  <React.Fragment>
                    <ListItem
                      fullWidth
                      alignItems="flex-start"
                      key={materialCode}
                    >
                      <ListItemAvatar>{getStokColor(s)}</ListItemAvatar>
                      <ListItemText
                        primary={
                          <Typography
                            key={materialCode}
                            variant="body1"
                            className={classes.nestedRight}
                          >
                            <b>{materialCode}</b>
                          </Typography>
                        }
                        secondary={
                          <React.Fragment>
                            <Typography
                              component="span"
                              variant="h6"
                              className={classes.inline}
                              color="textPrimary"
                            >
                              {t('StorageDesc')} : {s.StorageLocation}
                              <br />
                              {t('lblAdet')} : {s.Quantity} 
                              <br />
                              {t('Tarih')} : {moment(s.Date).format('DD/MM/YYYY')}
                              <br />
                              {SessionUser.TenantId === 87 || SessionUser.TenantId === 16 && ( 
                                <div>
                                  {t('ETA')} : {s.ETA === new Date(0).getTime() || s.Quantity == 0 ? "-": moment(s.ETA).format('DD/MM/YYYY')}
                                </div>
                              )}
                            </Typography>
                          </React.Fragment>
                        }
                      />
                    </ListItem>
                    <Divider variant="inset" component="li" />
                  </React.Fragment>
                );
              })
            }
          </List>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setServiceShopMaterialPopUp(false)} color="primary">
            {t('lblOk')}
          </Button>
        </DialogActions>
      </Dialog>
    </Page>
  );
}
export default ServiceShopMaterial;
